import {AJAX} from "./ajax";

const clamp = (val, min, max) => Math.min(max, Math.max(min, val));

export class InputIncDec {
  constructor(opts) {
    this.$el = $(opts.el);
    this.$input = this.$el.find("input[type=number]");
    if (!this.$input.length) this.$input = this.$el.find("input[type=range]"); // range is valid, but number has precedence
    this.$decBtn = this.$el.find(".js-input-dec");
    this.$incBtn = this.$el.find(".js-input-inc");
    this.initClicks();
    this.initInputEvents();
    this.update();
  }

  initClicks() {
    this.$decBtn.on("click", () => this.update(-1));
    this.$incBtn.on("click", () => this.update(1));
  }

  initInputEvents() {
    this.$input.on("input change", () => { this.handleInputChange(); });
  }

  update(dir = null) {
    const step = +this.$input.prop("step");
    const [min, max] = this.getMinMax();
    const currValue = this.getInputValue();

    // closest valid
    let nextValue = currValue;

    // inequalities are false for null
    if (dir < 0) nextValue -= step;
    if (dir > 0) nextValue += step;

    if (isFinite(min)) {
      nextValue = min + clamp(Math.round((nextValue - min) / step) * step, 0, max - min);
    } else {
      nextValue = clamp(Math.round(nextValue / step) * step, 0, max);
    }

    this.updateDisabledStates(nextValue, min, max);

    if (dir !== null && nextValue !== currValue) {
      this.$input.val(nextValue);
      this.$input.trigger("input");
      this.$input.trigger("change");
    }
  }

  getInputValue() {
    return +this.$input.val();
  }

  getMinMax() {
    const propMin = this.$input.prop("min");
    const propMax = this.$input.prop("max");
    const min = propMin ? +propMin : -Infinity;
    const max = propMax ? +propMax : Infinity;
    return [min, max];
  }

  handleInputChange() {
    this.updateDisabledStates(this.getInputValue(), ...this.getMinMax());
  }

  updateDisabledStates(value, min, max) {
    this.$decBtn.prop("disabled", value === min);
    this.$incBtn.prop("disabled", value === max);
  }
}

export function initInputIncDec() {
  $(".js-input-incdec").each(function () {
    const $this = $(this);
    if ($this.data("inputIncDec")) return;
    $this.data("inputIncDec", new InputIncDec({
      el: this
    }));
  });
}

$(initInputIncDec);
AJAX.onUpdate(initInputIncDec);
